/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { DecisionDto } from './decisionDto.schema';

export const IReadOnlyListOfDecisionDto = zod.array(zod.lazy(() => DecisionDto));

export type IReadOnlyListOfDecisionDto = zod.input<typeof IReadOnlyListOfDecisionDto>;
export type IReadOnlyListOfDecisionDtoOutput = zod.output<typeof IReadOnlyListOfDecisionDto>;
